
export const RoutesPrivate={
    CIFRANEGRA: '/cifranegra'
}